import React, { useState } from 'react';
import { useUrlParams } from '../../hooks/useUrlParams';
import { useI18n } from '../../i18n/I18nProvider';
import { subscribeUser } from '../../lib/mailerlite';
import { supabase } from '../../lib/supabase';
import { toastError, toastInfo, toastSuccess } from '../ui/toastHelpers';

const EmailSubscription: React.FC = () => {
  // Get URL parameters for dynamic content
  const urlParams = useUrlParams();
  const utmSource = urlParams.get('utm_source') || 'angular-tests.dev';
  const utmTopic = urlParams.get('utm_topic') || 'testing_angular';

  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useI18n();

  const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      if (!email || !isValidEmail(email)) {
        throw new Error(t.emailSubscription.errorMessage);
      }

      const isSubscribed = await subscribeUser(email, utmTopic, utmSource);
      console.log('isSubscribed', isSubscribed);
      // 2. Recuperar los topics del usuario
      const { data } = await supabase.from('newsletter_subscriptions').select('topics').eq('email', email).single();

      const existingTopics = data?.topics || [];

      const topics = [...existingTopics, utmTopic];

      const topicsUnique = [...new Set(topics)];


      const { error } = await supabase.from('newsletter_subscriptions').upsert(
        [
          {
            email,
            source: utmSource,
            topics: topicsUnique,
          },
        ],
        {
          onConflict: 'email',
        }
      );

      if (error) {
        // Check if the error is due to duplicate email
        if (error.code === '23505') {
          toastInfo(t.emailSubscription.successMessage);
          setEmail('');
          return;
        }
        throw error;
      }
      toastSuccess(t.emailSubscription.successMessage);
      setEmail('');
    } catch (error) {
      toastError(t.emailSubscription.errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id='emailSubscription' className='py-16 bg-gray-50'>
      <div className='container mx-auto px-4'>
        <div className='max-w-2xl mx-auto text-center'>
          <h2 className='text-3xl font-bold mb-6'>{t.emailSubscription.title}</h2>
          <p className='text-gray-600 mb-8'>{t.emailSubscription.description}</p>
          <form onSubmit={handleSubmit} className='flex flex-col sm:flex-row gap-4 justify-center'>
            <input
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t.emailSubscription.placeholder}
              className='px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 flex-grow max-w-md'
              required
              disabled={isLoading}
            />
            <button
              type='submit'
              className='px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
              disabled={isLoading}
            >
              {isLoading ? t.emailSubscription.loading || 'Enviando...' : t.emailSubscription.button}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default EmailSubscription; 